import { render, staticRenderFns } from "./Synthesis.vue?vue&type=template&id=18bee1dc&"
import script from "./Synthesis.vue?vue&type=script&lang=js&"
export * from "./Synthesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports